// Web Audio buzzer/siren cues for the live scoreboard.
// No asset files needed — tones are synthesized via the Web Audio API.
// Browsers require a user gesture before audio can play, so call enableMatchAudio()
// from a click handler (e.g. an "Enable Sound" button) before cues will be audible.

let ctx = null;
let enabled = false;

export function enableMatchAudio() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return false;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  enabled = true;
  return true;
}

export function isMatchAudioEnabled() {
  return enabled;
}

export function disableMatchAudio() {
  enabled = false;
}

function tone(freq, start, dur, { type = "square", gain = 0.18 } = {}) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, start);
  g.gain.exponentialRampToValueAtTime(gain, start + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(g);
  g.connect(ctx.destination);
  osc.start(start);
  osc.stop(start + dur + 0.02);
}

// Distinct, recognisable cues per match event.
const CUES = {
  // 15:00 — Lock-In ends, dynamic tap-out window opens (rising double beep)
  lockin_end: (t) => { tone(660, t, 0.18); tone(990, t + 0.22, 0.28); },
  // 22:00 — substitutions hard-locked (low descending double)
  subs_locked: (t) => { tone(440, t, 0.2); tone(300, t + 0.24, 0.34); },
  // Period buzzer / hard stop
  period_end: (t) => { tone(520, t, 0.4, { type: "sawtooth" }); tone(520, t + 0.45, 0.4, { type: "sawtooth" }); },
  // Shot-clock violation (harsh buzz)
  shot_clock_violation: (t) => { tone(180, t, 0.5, { type: "sawtooth", gain: 0.22 }); },
  // Golden point armed (bright ping)
  golden_point: (t) => { tone(1320, t, 0.18, { type: "triangle" }); tone(1760, t + 0.18, 0.22, { type: "triangle" }); },
  // Clash — both golden buttons (urgent triple)
  clash: (t) => { tone(880, t, 0.12); tone(1320, t + 0.14, 0.12); tone(1760, t + 0.28, 0.3); },
  // Tap-out triggered (short blip)
  tapout: (t) => { tone(560, t, 0.16, { type: "triangle" }); },
  // Match end siren (long fanfare)
  match_end: (t) => { tone(660, t, 0.5, { type: "sawtooth" }); tone(880, t + 0.5, 0.5, { type: "sawtooth" }); tone(1100, t + 1.0, 0.7, { type: "sawtooth" }); },
};

export function playCue(kind) {
  if (!enabled || !ctx) return;
  const fn = CUES[kind];
  if (!fn) return;
  try {
    if (ctx.state === "suspended") ctx.resume();
    fn(ctx.currentTime + 0.02);
  } catch (_) { /* ignore */ }
}
